import { useState } from 'react'
import { useDimensionsContext } from './SvgWrapper'
import { sankey, sankeyLinkHorizontal } from 'd3-sankey'
import { Theme } from '../../styles/settings/theme'

const Sankey = ({ data }) => {
  const [hoveredName, setHoveredName] = useState(null)
  const dimensions = useDimensionsContext()
  const isSmall = dimensions.width < 768
  const createSankey = sankey()
    .nodeId((d) => d.category)
    .nodeWidth(14)
    .nodePadding(18)
    .nodeSort(null) // so that we can do our own sorting
    //.size([width, height]);
    .extent([
      [isSmall ? 130 : 200, 70],
      [dimensions.width - (isSmall ? 130 : 200), dimensions.height - 70]
    ])

  if (data) {
    const { n, l } = data

    var { nodes, links } = createSankey({
      nodes: n.map((d) => ({ ...d })),
      links: l.map((d) => ({ ...d }))
    })
  }
  const linkGenerator = sankeyLinkHorizontal()

  //to center numbers perfectly within the circles
  const calcNumPos = (d) => {
    return d.depth === 0 ? d.x0 + 16 : d.x0
  }

  //get names of first three nodes on right which will always be first three in array
  const highlight = nodes
    ?.map((node, i) => {
      return i < 3 ? node.name : null
    })
    .filter((item) => item)

  const $ = window.WILDLABS_VARS

  return (
    <g>
      <g fill="none">
        {/* links */}
        {links
          ? links.map((d) => (
              <g
                key={d.source.name}
                onMouseEnter={() => setHoveredName(d.source.name)}
                onMouseLeave={() => setHoveredName(null)}
              >
                <path
                  d={linkGenerator(d)}
                  stroke={
                    hoveredName === d.source.name
                      ? Theme.colors.orange
                      : highlight.includes(d.source.name)
                      ? Theme.colors.blue
                      : Theme.colors.lightGray
                  }
                  strokeWidth={hoveredName === d.source.name ? '1rem' : '.6rem'}
                  strokeOpacity={hoveredName === d.source.name ? '.75' : '.15'}
                ></path>
              </g>
            ))
          : null}
      </g>
      {/* circle nodes */}
      <g>
        {nodes
          ? nodes.map((d) => (
              <g key={d.y0 + d.x0}>
                <circle
                  cx={d.depth === 0 ? d.x0 + 16 : d.x0}
                  cy={d.y0 + 14}
                  r={d.x1 - d.x0}
                  fill={
                    hoveredName === d.name
                      ? Theme.colors.orange
                      : highlight.includes(d.name)
                      ? Theme.colors.blue
                      : Theme.colors.gray
                  }
                  onMouseEnter={() => setHoveredName(d.name)}
                  onMouseLeave={() => setHoveredName(null)}
                ></circle>
              </g>
            ))
          : null}
      </g>
      {/* text labels and numbers */}
      <g>
        {nodes
          ? nodes.map((d) => (
              <g
                key={d.y0 + d.x0}
                onMouseEnter={() => setHoveredName(d.name)}
                onMouseLeave={() => setHoveredName(null)}
              >
                <text
                  x={d.depth === 0 ? d.x1 - 22 : d.x0 + 22}
                  y={(d.y1 + d.y0) / 2}
                  dy={'0.35em'}
                  textAnchor={d.depth === 0 ? 'end' : 'start'}
                  fill={
                    hoveredName === d.name
                      ? Theme.colors.orange
                      : Theme.colors.black
                  }
                  fontWeight={600}
                  fontSize={isSmall ? 12 : 16}
                >
                  {d.name}
                </text>
                <text
                  x={calcNumPos(d)}
                  y={d.y0 + 14}
                  dy={'0.35em'}
                  textAnchor="middle"
                  fill={Theme.colors.white}
                  fontWeight={700}
                  fontSize={isSmall ? 11 : 14}
                >
                  {d.depth === 0 ? d.leftRank : d.rightRank}
                </text>
              </g>
            ))
          : null}
      </g>
      {/* column labels at top -- 2 lines for each */}
      <g
        fill={Theme.colors.black}
        fontWeight={700}
        fontSize={isSmall ? Theme.fontSizes[0] : Theme.fontSizes[3]}
      >
        <text
          x={nodes ? nodes[nodes.length - 1].x0 + 25 : 0}
          y={20}
          textAnchor="end"
        >
          {$.perf_titles.subtitleA[0]}
        </text>
        <text
          x={nodes ? nodes[nodes.length - 1].x0 + 25 : 0}
          y={45}
          textAnchor="end"
        >
          {$.perf_titles.subtitleA[1]}
        </text>
        <text x={nodes ? nodes[0].x1 - 25 : 0} y={20}>
          {$.perf_titles.subtitleB[0]}
        </text>
        <text x={nodes ? nodes[0].x1 - 25 : 0} y={45}>
          {$.perf_titles.subtitleB[1]}
        </text>
      </g>
    </g>
  )
}

export default Sankey
